import styled from "styled-components";

import { Button as ButtonDs } from "ds/Button";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const Controls = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
export const Filter = styled.div`
  flex: 1;
`;
export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
export const Button = styled(ButtonDs)<{
  active?: boolean;
  disabled?: boolean;
}>`
  background-color: ${({ disabled, active }) =>
    disabled === true
      ? "var(--mode-bg-none-default)"
      : active === true
        ? "var(--timerange-section-background-color, var(--section-color-primary-100-background-color, var(--color-primary-100)))"
        : "var(--mode-bg-none-default)"};
  color: ${({ disabled, active }) =>
    disabled === true
      ? "var(--mode-vector-neutral-weakest)"
      : active === true
        ? "var(--timerange-button-color, var(--button-color-primary-600-color, var(--color-primary-600)))"
        : "var(--button-granite-color, var(--granite))"};
  &:hover {
    background-color: var(
      --timerange-section-background-color,
      var(
        --section-color-primary-100-background-color,
        var(--color-primary-100)
      )
    );
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Cell = styled.div`
  flex: 1;
  overflow: hidden;
`;
